import React from "react";
import { MdVerified, MdPolicy, MdBlock, MdHandshake, MdPerson, MdRequestQuote, MdAccountBox, MdContactPhone, MdRateReview, MdDashboard } from "react-icons/md";
import Heading from "../../components/common/Typography/Heading";
import SpecialText from "../../components/common/Typography/SpecialText";
import Paragraph from "../../components/common/Typography/Paragraph";

const points = [
  {
    title: "Verified Businesses",
    desc: "Every business on Trades Poster must complete ABN, license, mobile, and ID verification. This ensures you're dealing with legitimate, professional operators — not fake profiles. Only verified businesses are allowed to create posts or respond to customers.",
    icon: <MdVerified />,
  },
  {
    title: "Licensed & Insured",
    desc: "All businesses must upload valid trade licenses and insurance documents. You can view this on their profile, giving you confidence in their qualifications. It’s about hiring safely, especially for high-risk or compliance-based work.",
    icon: <MdPolicy />,
  },
  {
    title: "No Taskers",
    desc: "Trades Poster does not allow gig workers, odd-jobbers, or casual task posters. Only registered trade businesses can join and offer services. This keeps the quality high and the platform focused on real trade professionals.",
    icon: <MdBlock />,
  },
  {
    title: "Negotiate & Pay Directly",
    desc: "You speak with businesses directly to set job scope, timing, and payment terms. There’s no middleman, no platform commission, and no enforced pricing rules. Once you agree on terms, payment is handled privately between you and the business.",
    icon: <MdHandshake />,
  },
  {
    title: "Customer Control",
    desc: "Businesses cannot message you first or chase leads — only you decide who to contact. This puts you in full control of the interaction and protects your privacy. No unwanted spam or cold outreach — ever.",
    icon: <MdPerson />,
  },
  {
    title: "Request Quote",
    desc: "Use the “Request a Quote” form on business profiles to explain your job clearly. Once submitted, your request is sent to up to 5 relevant businesses near your area. Businesses reply in your inbox, allowing you to compare options and ask questions. It’s a structured, professional way to start the conversation.",
    icon: <MdRequestQuote />,
  },
  {
    title: "View Profiles",
    desc: "Every business has a dedicated profile showing services, coverage area, and badges. You’ll also see their reviews, portfolio images, and a link to their Google Business profile. Profiles help you compare and choose with confidence.",
    icon: <MdAccountBox />,
  },
  {
    title: "Contact Options",
    desc: "You can contact businesses through direct message, phone, email, or social links. All contact methods are clearly displayed on posts and business profiles. You choose how to reach out — no forced communication flows.",
    icon: <MdContactPhone />,
  },
  {
    title: "Leave Reviews",
    desc: "After a job is complete, you can leave a verified review on the business’s profile. Only customers with verified accounts can submit reviews — ensuring authenticity. This helps others hire with confidence and keeps the platform transparent.",
    icon: <MdRateReview />,
  },
  {
    title: "Customer Dashboard",
    desc: "Manage all your quotes, messages, and active conversations in one place. You can track follow-ups, view past jobs, and access review history easily. It’s your personal control panel for managing every interaction.",
    icon: <MdDashboard />,
  },
];

const CustomerFeaturePoints = () => (
  <section className="w-full">
    <div className="tp-container-small mx-auto">
      <Heading variant="h2" className="text-offblack mx-auto mb-20">
        Why Choose Trades Poster
      </Heading>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-16 gap-y-16">
        {points.map((point, idx) => (
          <div key={idx} className="flex flex-col items-start">
            <div className="w-16 h-16 mb-5 flex items-center justify-center rounded-xl bg-white text-4xl">
              {point.icon}
            </div>
            <div>
              <Paragraph variant="MainParagraph" className="mb-1"><span className="font-bold">{point.title}.</span> {point.desc}</Paragraph>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CustomerFeaturePoints; 